<template>
    <div class='app' v-if="show">
        <div class='back'></div>
        <div class='main'>
            <div class='nav'>
                <div class='tab' v-for="(item,index) in kjdata" :key="index" :class="index==i?'act':''" @click='change(index)'>
                    {{tabList[index].name}}<p>{{item.Moon}}月{{item.Day}}日</p>
                </div>
            </div>
            <div class='content' v-show='showcon'>
                <div class='kj_top'>
                    <span style="color: #008800">{{kjdata[i].Qi}}</span>期开奖结果
                    <a :href='his[i]'>开奖记录</a> 
                </div>
                <ul>
                    <li v-for="(item,index) in pma[i]" :key="index">
                        <p class='num' :style="{'background':colorChange(item.style)}">{{item.number}}</p><p class='sx'>{{item.sx}}</p>
                    </li>
                </ul>
                <div class='tm'><p class='num' :style="{'background':colorChange(tma[i].style)}">{{tma[i].number}}</p><p class='sx'>{{tma[i].sx}}</p></div>
                <div class="next_kj">
                    <span class="qi" style="color:red">
                        {{kjdata[i].Nq}}</span>期开奖:<span id="nx">
                        <b>{{kjdata[i].Moon}}</b>月<b>{{kjdata[i].Day}}</b>日{{kjdata[i].Time}}(<b>{{kjdata[i].Week}}</b>)
                    </span>
                </div>
                <div class="link">
                    <a v-for="(item,index) in link[i]" :key='index' :href="item">{{index}}</a>
                </div>
            </div>
        </div>
        <div class="video" v-if="i==1||i==3">
            <p>49.me 【开奖直播快人3秒】</p>
            <iframe v-if="i==1" style="margin: 0;width: 100%;height: 242px;border:none" src="https://77.2135a.cc:1888/video"></iframe>
            <video-player v-if="i==3" class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @ready="playerReadied"
                  @ended="onPlayerEnded($event)"
            >
            </video-player>
            <div class="block" v-if="i==3&&showvideoblock">
                <p>搅珠直播开播时间为每晚21:30(北京时间) ,敬请查看</p>
                <button>点击刷新</button>
                <button>开启声音</button>
            </div>
        </div>
        <div class='ref' @click='getData(i)'>刷新</div>
        <a class="dh66" href="https://66dh.am6.biz:1888">
           66导航全讯网 
        </a>
        <div class='down'><a href="https://down.lianliao.me/baomakaijiang">下载报码开奖APP，查看开奖更方便<span>↓</span></a></div>
        <div class='down'><a href="https://down.lianliao.me/baomakaijiang">苹果APP万能票口令：3636<span>↓</span></a></div>
        <div>请记好永久书签 <a style="color: #f00;text-decoration: underline;" href="https://www.36bm.com">https://32bm.com</a></div>
    </div>
</template>
<style lang="less" scoped>
    .video{
        font-family: Avenir,Helvetica,Arial,sans-serif;
        text-align: center;
        color: #2c3e50;
        margin: 0 auto;
        background: #000;
        border: 2px solid #0090ff;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 5px;
        max-width: 600px;
        >p{
            line-height: 30px;
            font-weight: 900;
            background: linear-gradient(rgb(14, 113, 255), rgb(255, 255, 255));
        }
        .block{
            position: absolute;
            z-index: 9;
            top: 30px;
            color: #fff;
            width: 100%;
            background: #000;
            height: 100%;
            >p{
                margin: 10% 10px;
            }
            >button{
                margin: 0 20px;
                padding: 2px 10px;
            }
        }
    }
    .dh66:active{
        box-shadow: none;
    }
    .dh66{
        line-height: 2rem;padding: .3rem 5rem;color: #fff;border-radius: 1rem;box-shadow: 1px 2px 1px 1px #bc8533;background: linear-gradient(#ffe1b3,#FF9800);text-shadow: 1px 1px 1px #6d6d6d;
    }
    .down{
        font-size: 0.9rem;margin-top: 0.3rem;background: #5a5a5a;padding: .3rem;color: #fff;
        a{color: #fff;}
        span{
            display: inline-block;
            padding: 0 0.3rem;
            background: #ff0000;
            font-weight: 800;
            font-family: '黑体';
            line-height: 1.4rem;
            height: 1.3rem;
            margin-left: .5rem;
            border-radius: 6px;
            box-shadow: 0px 2px 1px #ff9335;
            border: 1px solid #ffffff;
            cursor: pointer;position: relative;
        }
        span:active{
            box-shadow: none;top: 1px;
        }
    }
    .ref{
        position: fixed;
        z-index: 999;
        top: 11rem;
        right: 4%;
        border-radius: 50%;
        background: #ff6900;
        width: 2rem;
        height: 2rem;
        line-height: 2.1rem;
        text-align: center;
        box-shadow: 0px 3px 1px #cd0a0a;
        color: #fdfdfd;
        border: 1px solid #fff;
        font-size: .8rem;
        cursor: pointer;
    }
    .ref:active{
        box-shadow: none;
        top: 11.1rem;
        border: 1px solid #fd5d18;
    }
    .back{
        width: 100%;
        height: 300px;
        background:linear-gradient(#5a5a5a8a,#d500fe00);
        margin-bottom: -300px;
        z-index: -1;
    }
    .main{
        padding: 2% 1%;
        .nav{
            display: flex;
            justify-content: space-between;
            .tab{
                cursor: pointer;
                width: 100%;
                text-align: center;
                font-family: 'PingFangSC-Regular,Microsoft YaHei,Helvetica';
                background: #fff;
                border-radius: 10px;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
                border: 0.5px solid #0ed800;
                font-size: 16px;
                font-weight: 800;
                p{
                    font-size: 12px;
                    line-height: 14px;
                    text-shadow: none;
                    font-weight: 500;
                }
            }
            .act{
                font-weight: 600;
                text-shadow: 1px 1px 1px #000;
                color: #fff;
                background: #0ed800;
                box-shadow: inset 0px 2px 2px 0px #ffffff;
            }
        }
        .content{
            height: 210px;
            background:#f6f6f6;
            border-radius: 12px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            box-shadow: 0 4px 8px 0 rgba(148, 148, 148, 0.7607843137254902);
            border: 1px solid #0ed800;
            .link{
                display: flex;
                justify-content: space-around;
                a{
                    font-size: 18px;
                    color: #3c79ff;
                    font-weight: 600;
                    text-decoration: none;
                    line-height: 26px;
                }
            }
            .kj_top{
                text-align: center;
                font-weight: bold;
                background:#ffde9b;
                a{
                        color: #3c79ff;margin-left: .5rem;
                }
            }
            ul{
                display: flex;
                li{
                    width: calc(100%/6);
                    border-left: solid 1px #666666;
                }
                li:first-child{
                    border:none
                }
            }
            .num{
                line-height: 44px;
                font-size: 36px;
                font-weight: bold;
                color: #fff;
            }
            .sx{
                font-family: '宋体';
                font-weight: 600;
                color: #040404;
            }
            .next_kj{
                line-height: 1.8rem;background: #ffdb9b;color: #036103;
                b{color:#f00;font-weight: 500;};
            }
        }
    }
</style>
<script>
import {videoPlayer} from 'vue-video-player';
export default {
    components: {
        videoPlayer
    },
    data() {
        return {
            i:0,
            tabList:[
                {name:'天天澳',cod:'am',time:['22','14','22','40']},
                {name:'新澳',cod:'am_plus',time:['21','14','21','40']},
                {name:'老澳',cod:'oldam',time:['21','14','21','40']},
                {name:'港彩',cod:'xg',time:['21','00','21','40']},
                {name:'快乐8',cod:'fckl8',time:['20','46','20','59']},
                {name:'台彩',cod:'tw',time:['20','46','20','59']},
                // {name:'新彩',cod:'xjp',time:['18','18','18','50']},
            ],
            his: [
                "https://9.48kk50.com:1888/Kj/index.html?48am", 
                "https://9.48kk50.com:1888/Kj/index.html", 
                "https://kj.48kjj.com:1888/api/?oldam", 
                "https://kj.48kjj.com:1888/api/?xg", 
                "https://kj.48kjj.com:1888/api/?kl8", 
                "https://kj.48kjj.com:1888/api/?tw", 
                "https://kj.48kjj.com:1888/api/?xjp"],
            link: [
                {
                "澳门资料": "https://48c.app:1888/",
                "澳门彩吧": "https://www.48n7.com:1888/",
                "彩图": "https://www.69tk1.vip:443/",
                "报码②区": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?48am"
                }, 
                {
                "澳门资料": "https://48k.494767.com:8443/",
                "澳门天空": "https://tkcp.am6.biz:1888",
                "图库": "https://tk.am6.biz:1888/",
                "报码②区": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?am"
                }, 
                {
                "老澳挂牌": "https://99.www-556655.com:1888/",
                "报码②区": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?oldam"
                }, 
                {
                "特区总站": "https://135.494767.com:8443/",
                "高手一肖": "https://t49.am6.biz:1888/",
                "图库": "https://tk.am6.biz:1888/",
                "报码②区": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?xg"
                }, 
                {
                "开奖直播": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?kl8"
                }, 
                {
                "台湾资料": "https://tk.am6.biz:1888/",
                "高手一肖": "https://tk.am6.biz:1888/",
                "图库": "https://tk.am6.biz:1888/",
                "报码②区": "https://xn--p1b1g6b.xn--0dc8c1a2eh.xn--gecrj9c:1888/?tw"
            }],
            kjdata:[
                { "Data": { "1": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "2": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "3": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "4": { "nim": "/", "number": "00", "style": "/", "sx": "/" }, "5": { "nim": "/", "number": "00", "style": "blue", "sx": "/" }, "6": { "nim": "/", "number": "00", "style": "red", "sx": "/" }, "7": { "nim": "/", "number": "00", "style": "red", "sx": "/" } }, "Day": "07", "Moon": "06", "Nq": "2021159", "Qi": "2021158", "Time": "21:34", "Week": "周二", "Auto": true }, { "Data": { "1": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "2": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "3": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "4": { "nim": "/", "number": "00", "style": "/", "sx": "/" }, "5": { "nim": "/", "number": "00", "style": "blue", "sx": "/" }, "6": { "nim": "/", "number": "00", "style": "red", "sx": "/" }, "7": { "nim": "/", "number": "00", "style": "red", "sx": "/" } }, "Day": "08", "Moon": "06", "Nq": "044", "Qi": "043", "Time": "21:32", "Week": "周二", "Auto": false }, { "Data": { "1": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "2": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "3": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "4": { "nim": "/", "number": "00", "style": "/", "sx": "/" }, "5": { "nim": "/", "number": "00", "style": "blue", "sx": "/" }, "6": { "nim": "/", "number": "00", "style": "red", "sx": "/" }, "7": { "nim": "/", "number": "00", "style": "red", "sx": "/" } }, "Day": "08", "Moon": "06", "Nq": "055", "Qi": "054", "Time": "20:50", "Week": "周二", "Auto": false }, { "Data": { "1": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "2": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "3": { "nim": "/", "number": "00", "style": "green", "sx": "/" }, "4": { "nim": "/", "number": "00", "style": "/", "sx": "/" }, "5": { "nim": "/", "number": "00", "style": "blue", "sx": "/" }, "6": { "nim": "/", "number": "00", "style": "red", "sx": "/" }, "7": { "nim": "/", "number": "00", "style": "red", "sx": "/" }}, "Day": "10", "Moon": "06", "Nq": "3668", "Qi": "3667", "Time": "18:40", "Week": "周四", "Auto": false }
            ],
            pma:[],
            tma:[],
            show:0,
            showcon:1,
            // host:'http://103.240.143.143:81/data/'
            host:'https://lty-s3.s3.ap-east-1.amazonaws.com/49_tk/open_lottery/',
            //视频播放
            videoUrl:[
                'https://live.nodemedia.cn:8443/live/sony_4k_264.flv',
                'https://play3636.zdwafis.com/live/mosixmark.flv',
                'http://playertest.longtailvideo.com/adaptive/bipbop/gear4/prog_index.m3u8',
                'https://streamw-azs-51.on.cc/src/smil:remote1.smil/chunklist_b332000.m3u8',
                'https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/hls/xgplayer-demo.m3u8',
                'https://play3636.zdwafis.com/live/mosixmark.flv'
            ],
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: true, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: "application/x-mpegURL",   // 类型
                    withCredentials: false,
                    src: 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8'
                    // src: 'http://playertest.longtailvideo.com/adaptive/bipbop/gear4/prog_index.m3u8'
                    // src: 'https://sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo.flv'
                }],
                poster: "", //你的封面地址
                width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true
                }
            },
            gk: "",
            showvideoblock:true
        }
    },
    mounted () {
        // 检测当前时间，在开奖时间段内则启用自动请求
        this.timer = setInterval(this.time_range, 3000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    created() {
        // 识别请求的开奖类型
        let url = window.location.search;
        let type = 0;
        switch (url) {
            case '?am':
                type = 1;
                break;
            case '?oldam':
                type = 2;
                break;
            case '?xg':
                type = 3;
                break;
            case '?kl8':
                type = 4;
                break;
            case '?tw':
                type = 5;
                break;
            case '?xjp':
                type = 6;
                break;
            default:
                type = 0
        }
        this.i=type;
        this.playerOptions.sources[0].src = this.videoUrl[this.i];
        this.firstGet();
    },
    computed: {
        player() {
        return this.$refs.videoPlayer.player
        }
    },
    watch: {
        gk: function () {
        }
    },
    methods: {
        onPlayerPlay(player) {
        // 播放回调
        },
        onPlayerPause(player) {
        // 暂停回调
        },
        onPlayerEnded($event) {
        //播放完成回调
        },
        goFast() {
        //快进
        this.gk += 5;
        this.$refs.videoPlayer.player.currentTime(this.gk)
        },
        goBack() {
        //后退
        this.gk -= 5;
        this.$refs.videoPlayer.player.currentTime(this.gk);
        },
        onPlayerTimeupdate(player) {
        //获取当前播放时间
        this.gk = player.cache_.currentTime;
        },
        playerReadied(player) {
        player.currentTime(this.gk);
        },
        //背景颜色转换
        colorChange(c){
            let r = c;
            if(c=="red"){
                r = "#ff2020";
            }
            if(c=="blue"){
                r = "#00a1ff";
            }
            if(c=="green"){
                r = "#43bb05";
            }
            return r;
        },
        // 时间检测函数
        time_range(){
            var b = new Date();
            var e = new Date();
            var n = new Date();
            var type = this.i;
            var tplist = this.tabList;
            let h = n.getHours();
            let m = n.getMinutes();
            if(h==21&&m>29&&m<35){
                this.showvideoblock = false;
            }else{
                this.showvideoblock = true;
            }
            
            let kjtime = tplist[type]['time']; 
            let name = tplist[type]['name'];
            // let code = tplist[type]['cod'];
            
            var str = '['+name+']开奖时间段'+kjtime[0]+'：'+kjtime[1]+'——'+kjtime[2]+'：'+kjtime[3]+'，';
            
            b.setHours(kjtime[0]);
            b.setMinutes(kjtime[1]);
            e.setHours(kjtime[2]);
            e.setMinutes(kjtime[3]);
            
            if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
                str = str + '现在处于开奖时间段，每3秒自动获取开奖信息。';
                console.log(str);
                this.getData(type);
            } else {
                str = str + '现在不在开奖时间段。';
                console.log(str);
            }
        },
        //加载数据
        setData(data,i){
            data['Time'] = data['Time'].replace('点',':').replace('分','');
            this.$set(this.kjdata,i,data);
            
            var d = data.Data;
            if(JSON.stringify(d)=='{}' || d==null){
                d = { "1": { "nim": "", "number": "", "style": "", "sx": "" }, "2": { "nim": "", "number": "", "style": "", "sx": "" }, "3": { "nim": "", "number": "", "style": "", "sx": "" }, "4": { "nim": "", "number": "", "style": "", "sx": "" }, "5": { "nim": "", "number": "", "style": "", "sx": "" }, "6": { "nim": "", "number": "", "style": "", "sx": "" }, "7": { "nim": "", "number": "", "style": "", "sx": "" }};
            }
            var arr = [];
            for(var k=0;k<6;k++){
                arr[k] = d[k+1];
            }
            this.$set(this.pma,i,arr);
            this.$set(this.tma,i,d[7]);
        },
        //请求数据
        getData(n) {
            let t = new  Date().getTime();
            let url = ''+this.host+'v_'+this.tabList[n].cod+'.json?'+t;
            this.$axios.get(url).then(res=>{ 
                this.setData(res.data,n);
                });
        },  
        //切换
        change(n){
            this.i = n;
            this.getData(n);
            this.playerOptions.sources[0].src = this.videoUrl[this.i];
        },
        //初始化
        firstGet(){
            let t = new  Date().getTime();
            let url0 = this.host+'v_am.json?'+t;
            let url1 = this.host+'v_am_plus.json?'+t;
            let url2 = this.host+'v_oldam.json?'+t;
            let url3 = this.host+'v_xg.json?'+t;
            let url4 = this.host+'v_fckl8.json?'+t;
            let url5 = this.host+'v_tw.json?'+t;
            // let url6 = this.host+'v_xjp.json?'+t;
            Promise.all([
                    new Promise((resolve,reject)=>{
                        this.$axios(url0).then((res)=>{
                            this.setData(res.data.data,0);
                            resolve(res);
                        })
                    }),
                    new Promise((resolve,reject)=>{
                        this.$axios(url1).then((res)=>{
                            this.setData(res.data.data,1);
                            resolve(res);
                        })
                    }),
                    new Promise((resolve,reject)=>{
                        this.$axios(url2).then((res)=>{
                            this.setData(res.data.data,2);
                            resolve(res);
                        })
                    }),
                    new Promise((resolve,reject)=>{
                        this.$axios(url3).then((res)=>{
                            this.setData(res.data.data,3);
                            resolve(res);
                        })
                    }),
                    new Promise((resolve,reject)=>{
                        this.$axios(url4).then((res)=>{
                            this.setData(res.data.data,4);
                            resolve(res);
                        })
                    }),
                    new Promise((resolve,reject)=>{
                        this.$axios(url5).then((res)=>{
                            this.setData(res.data.data,5);
                            resolve(res);
                        })
                    }),
                ]).then(res=> {
                this.show=1;               
            })
        }
    }
}
</script>